export default __webpack_public_path__ + "static/media/luis.9c193bd3.jpg";